import { Link, Typography, Box } from '@mui/material'
import React from 'react'

const AuthFooter = () => {
  return (
    <Box sx={{display:'flex', pb:'2em', mt:"5em", justifyContent:'center', px:'0.5em'}}>
        <Typography variant='small' textAlign={'center'}>
        ©2023 iDonatio UK LTD. All rights reserved.
        <Link sx={{ml:'1em'}} href='/donor-privacy-policy'>Donor Privacy policy</Link>
      <Link sx={{ml:'1em'}} href='/donee-privacy-policy'>Donee Privacy policy</Link>
      <Link sx={{ml:'1em'}} href='/donor-terms-of-service'>Donor Terms & conditions</Link>
      <Link sx={{ml:'1em'}} href='/donee-terms-of-service'>Donee Terms & conditions</Link>
      {/* <a style={{marginLeft:'1em', color:"#2962FF", textDecorationColor:'rgba(41, 98, 255, 0.4)'}}  href='https://www.gov.uk/donating-to-charity/gift-aid'>Learn about Gift Aid</a> */}
      </Typography>
    </Box>
  )
}

export default AuthFooter